import React from 'react';

export default () => (
    <div className="bounds">
        <h1>Not Found</h1>
        <p>Oops! The page you're looking for wasn't found.</p>
    </div>
)